import { render, staticRenderFns } from "./RegrasAcessoForm.vue?vue&type=template&id=0461f842&"
import script from "./RegrasAcessoForm.vue?vue&type=script&lang=js&"
export * from "./RegrasAcessoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports